__turbopack_context__.v({
  "bgPig": "pig-module-scss-module__dI3s1q__bgPig",
  "bgPigWrapper": "pig-module-scss-module__dI3s1q__bgPigWrapper",
  "observer": "pig-module-scss-module__dI3s1q__observer",
  "pig": "pig-module-scss-module__dI3s1q__pig",
});
